<div
    *ngIf="variant === 'boolean'"
    class="hub-input eu-display_flex eu-align-items_center"
    style="gap: 1.25rem"
>
    <label *ngIf="label" class="emd-label">
        {{ label }}
        <i
            *ngIf="useHint"
            title="Clique para mais informações"
            (click)="handleHint($event)"
            class="ipv-help-icon ml-2 fa fa-question-circle"
            aria-hidden="true"
            style="cursor: pointer"
        ></i>
    </label>
    <span *ngIf="value" class="active-tag emd-tag _color_primary">Ativado</span>
    <span *ngIf="!value" class="active-tag emd-tag">Desativado</span>
</div>

<div
    *ngIf="variant === 'currency'"
    class="hub-input eu-display_flex eu-align-items_center"
    style="gap: 1.25rem"
>
    <label *ngIf="label" class="emd-label">
        {{ label }}
        <i
            *ngIf="useHint"
            title="Clique para mais informações"
            (click)="handleHint($event)"
            class="ipv-help-icon ml-2 fa fa-question-circle"
            aria-hidden="true"
            style="cursor: pointer"
        ></i>
    </label>
    <span class="active-tag emd-tag _color_primary">{{ value | currency : 'BRL' }}</span>
</div>
